import React from 'react';

export default function AllProductsHeader() {
  return (
      <div className="hero-image-coll">
        <div className="hero-text-coll">
          <h2>Product Catalog</h2>
        </div>
      </div>
  );
}
